<template>
  <div>
    <div class="modelMain" v-if="porder_freight">
      <!-- {{ porder_detail }} -->
      <div class="huoyunTable">
        <div class="head tbc">
          <div
            class="tli"
            v-if="
              $fun.findNo(statusList, pageStatus) >=
                $fun.findNo(statusList, '已发货')
            "
          >
            {{ $fanyi("物流单号") }}
          </div>
          <div class="tli">{{ $fanyi("发送方式") }}</div>
          <div class="tli">{{ $fanyi("数量") }}</div>
          <div class="tli">{{ $fanyi("重量（千克）") }}</div>
          <div class="tli">{{ $fanyi("体积") }}(m³)</div>
        </div>
        <div class="body">
          <div class="opt tbc">
            <!-- @click="getlogisticsInformation(huoYunData.express_no)" -->
            <div
              class="tli blue"
              v-if="
                $fun.findNo(statusList, pageStatus) >=
                  $fun.findNo(statusList, '已发货')
              "
            >
              {{ huoYunData.express_no }}
            </div>
            <div class="tli">{{ huoYunData.logistics }}</div>
            <div class="tli">{{ porder_freight.length }}</div>
            <div class="tli">{{ all_weight }}</div>
            <div class="tli">{{ all_volume }}</div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modelMain"
      v-if="porder_foreign_express && porder_foreign_express.length"
    >
      <!-- {{ porder_detail }} -->
      <div class="huoyunTable">
        <div class="head tbc">
          <div class="tli">{{ $fanyi("欧盟内部运输") }}</div>
          <div class="tli">{{ $fanyi("物流单号") }}</div>
        </div>
        <div class="body">
          <div
            class="opt tbc"
            v-for="porder_foreign_express_item in porder_foreign_express"
            :key="porder_foreign_express_item.id"
          >
            <!-- 欧盟内部运输 -->
            <div class="tli">
              {{ porder_foreign_express_item.foreign_express }}
            </div>
            <!-- 物流单号 -->
            <div class="tli">
              <span
                class="blue aLink"
                @click="
                  $fun.routerToPage(
                    porder_foreign_express_item.foreign_express_url,
                    true,
                  )
                "
              >
                {{ porder_foreign_express_item.foreign_express_no }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="logisticsInfoBox modelMain" v-if="showlogisticsData">
      <div class="logisticsInfoBoxT1">{{ $fanyi("国家后勤") }}</div>
      <!-- 图标列表 -->
      <div class="dip iconListBox">
        <div
          class="flex acenter"
          v-for="(item, index) in iconList"
          :key="index"
          :class="{ active: index + 1 <= logistics_status }"
        >
          <div class="iconItemBox">
            <div class="iconBox">
              <img
                :src="index + 1 <= logistics_status ? item.img2 : item.img"
              />
            </div>
            <span>
              {{ item.font }}
            </span>
          </div>
          <div class="line" v-if="index != iconList.length - 1"></div>
        </div>
      </div>
      <!-- 物流状态列表 -->
      <div class="scrollHeightBox">
        <div class="logisticsStatusList">
          <div
            class="statusItem "
            :class="{ active: logindex == 0 }"
            v-for="(logitem, logindex) in logisticsData"
            :key="logindex"
          >
            <p class="con ">
              {{ logitem.msg }}
            </p>
            <p class="otime">{{ logitem.datetime }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showlogisticsData: false,
      logisticsData: [],
    };
  },
  components: {},
  computed: {
    iconList() {
      return [
        {
          img:
            "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202503/67ce90efc82ff.svg",
          img2: require("@/assets/user-img/delivery-timeline/dgoods-step1-active-green.svg"),
          font: this.$fanyi("由Rakumart管理的运输"),
        },
        {
          img:
            "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202503/67ce90f4a01bc.svg",
          img2: require("@/assets/user-img/delivery-timeline/dgoods-step2-active-green.svg"),
          font: this.$fanyi("运输中"),
        },
        {
          img:
            "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202503/67ce90f92e070.svg",
          img2: require("@/assets/user-img/delivery-timeline/dgoods-step3-active-green.svg"),
          font: this.$fanyi("欧盟内部交付"),
        },
        {
          img:
            "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202503/67ce90fdcb888.svg",
          img2: require("@/assets/user-img/delivery-timeline/dgoods-step4-active-green.svg"),
          font: this.$fanyi("已签收"),
        },
      ];
    },
    all_weight() {
      let weight = 0;
      this.porder_freight.forEach((item) => {
        weight += item.weight;
      });
      return weight;
    },
    all_volume() {
      let volume = 0;
      this.porder_freight.forEach((item) => {
        volume += item.volume;
      });
      return volume;
    },
    logistics_status() {
      return (this.$parent.datas.result || {}).logistics_status || 1;
    },
    statusList() {
      return this.$parent.statusList;
    },
    pageStatus() {
      return this.$parent.pageStatus;
    },
    porder_freight() {
      if (
        this.$parent.datas.result &&
        this.$parent.datas.result.porder_freight
      ) {
        return this.$parent.datas.result.porder_freight;
      }
    },
    porder_foreign_express() {
      if (
        this.$parent.datas.result &&
        this.$parent.datas.result.porder_foreign_express
      ) {
        return this.$parent.datas.result.porder_foreign_express;
      }
    },
    huoYunData() {
      if (this.$parent.datas.result) {
        return {
          logistics: this.$parent.datas.result.logistics_name,
          express_no: this.$parent.datas.result.express_no,
          billing_parameter: this.$parent.datas.result.billing_parameter,
          // 2023/02/02 15:37 这里取国际物流费用
          amount: this.$fun.EURNumSegmentation(
            this.$parent.datas.result.logistics_price,
          ),
        };
      }
    },
  },
  created() {},
  methods: {
    // 获取物流跟踪信息
    getlogisticsInformation(express_no) {
      this.$parent.fullscreenLoading = true;
      this.logisticsData = [];
      this.$api
        .getPorderExpressTrace({ express_no: express_no })
        .then((res) => {
          ////console.log('事件名',res)
          this.$parent.fullscreenLoading = false;
          if (res.code != 0 || res.data == [] || res.data == null) return;
          //接下来的操作
          this.logisticsData = (res.data || {}).trace;
          this.showlogisticsData = true;
          this.$forceUpdate();
        });
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "../../../../../../../css/mixin.scss";

.modelMain {
  width: $pageWidth;
  margin: 20px auto;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e1e1e1;
  padding: 30px;

  .huoyunTable {
    .head {
      background: #f4f4f4;
      height: 56px;

      &.tbc {
        .tli {
          border: none !important;
        }
      }
    }

    .body {
      background-color: white;
      border: 1px solid #ededed;

      .opt {
        height: 60px;
      }
    }

    .tbc {
      display: flex;
      align-items: center;

      .tli {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        text-align: center;
        border-left: #ededed solid 1px;
        border-bottom: #ededed solid 1px;
      }
    }
  }

  .tipBox {
    line-height: 1;
    font-size: 13px;
    margin-top: 20px;
  }

  .logisticsInfoBoxT1 {
    line-height: 1;
    margin-bottom: 40px;
    font-weight: bold;
    font-size: 18px;
  }

  .iconListBox {
    margin-bottom: 60px;
  }

  .iconListBox {
    .iconItemBox {
      width: 165px;

      .iconBox {
        width: 80px;
        height: 80px;
        background: #f4f4f4;
        border-radius: 20px;
        @extend .dip;
        margin: 0 auto 10px;
        img {
          width: 43px;
        }
      }

      span {
        display: block;
        text-align: center;
        line-height: 23px;
        font-size: 18px;
        font-weight: bold;
        min-height: 46px;
      }
    }
    .line {
      border-top: 2px dashed #f4f4f4;
      background-size: 40px;
      background-position: center;
      width: 128px;
      display: block;
      height: 0px;
      margin-bottom: 56px;
    }

    .active {
      .iconItemBox {
        .iconBox {
          background: #eaf8e8;
        }
        span {
          color: #009246;
        }
      }
      .line {
        border-color: #009246;
      }
    }
  }

  .scrollHeightBox {
    height: 350px;
    overflow-y: auto;
    .logisticsStatusList {
      margin-left: 10px;

      .statusItem {
        position: relative;
        padding-left: 30px;
        padding-bottom: 40px;
        border-left: #e1e1e1 solid 2px;
        &:last-child {
          border-color: transparent;
          padding-bottom: 0px;
        }
        &::before {
          content: " ";
          width: 18px;
          height: 18px;
          background: #e1e1e1;
          border-radius: 50%;
          display: block;
          position: absolute;
          top: 0px;
          left: -10px;
        }

        .con {
          font-weight: 500;
          font-size: 18px;
          line-height: 23px;
          margin-bottom: 10px;
        }
        .otime {
          line-height: 1;
          font-size: 16px;
          color: #868686;
        }
      }
      .statusItem.active {
        &::before {
          background: #009246;
        }
        .con {
          color: #009246;
        }
      }
    }
  }
}

.blue {
  color: #009246;
}
</style>
